"use strict";

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var _extends2 = require("babel-runtime/helpers/extends"),
    _extends3 = _interopRequireDefault(_extends2),
    _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of"),
    _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf),
    _classCallCheck2 = require("babel-runtime/helpers/classCallCheck"),
    _classCallCheck3 = _interopRequireDefault(_classCallCheck2),
    _createClass2 = require("babel-runtime/helpers/createClass"),
    _createClass3 = _interopRequireDefault(_createClass2),
    _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn"),
    _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2),
    _inherits2 = require("babel-runtime/helpers/inherits"),
    _inherits3 = _interopRequireDefault(_inherits2),
    _react = require("react"),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require("prop-types"),
    _globals = require("./globals"),
    _Step = require("./Step"),
    _Step2 = _interopRequireDefault(_Step),
    _debounce = require("./debounce"),
    _debounce2 = _interopRequireDefault(_debounce),
    propTypes = {
  when: _propTypes.bool,
  spy: _propTypes.any,
  effect: _propTypes.string,
  collapse: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.string]),
  duration: _propTypes.number,
  delay: _propTypes.number,
  count: _propTypes.number,
  forever: _propTypes.bool,
  tag: _propTypes.string,
  step: (0, _propTypes.oneOfType)([(0, _propTypes.instanceOf)(_Step2.default), _propTypes.string]),
  className: _propTypes.string,
  style: _propTypes.object,
  props: _propTypes.object,
  force: _propTypes.bool,
  bypass: _propTypes.bool,
  fraction: _propTypes.number,
  onReveal: _propTypes.func,
  children: _propTypes.node.isRequired,
  in: _propTypes.object,
  out: (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.bool])
},
    defaultProps = {
  duration: 1e3,
  delay: 0,
  count: 1,
  fraction: .2,
  tag: "div",
  when: !0
},
    contextTypes = {
  stepper: _propTypes.object
},
    RevealBase = function (e) {
  function t(e) {
    (0, _classCallCheck3.default)(this, t);
    var s = (0, _possibleConstructorReturn3.default)(this, (t.__proto__ || (0, _getPrototypeOf2.default)(t)).call(this, e));
    return s.state = {
      legacyMode: !1,
      style: {
        height: e.collapse ? 0 : void 0,
        visibility: e.collapse ? e.when || !e.out ? "visible" : "hidden" : void 0,
        opacity: !e.when && e.out ? 0 : void 0
      }
    }, s.isListener = !1, s.isShown = !!s.props.bypass, s.revealHandler = (0, _debounce2.default)(s.reveal.bind(s, !1), 66), s.resizeHandler = (0, _debounce2.default)(s.resize.bind(s), 500), s.invisible = (0, _debounce2.default)(s.invisible, 500), s.saveRef = function (e) {
      return s.el = e;
    }, s;
  }

  return (0, _inherits3.default)(t, e), (0, _createClass3.default)(t, [{
    key: "inViewport",
    value: function value() {
      if (!this.el || window.document.hidden) return !1;
      var e = this.el.offsetHeight,
          s = window.pageYOffset - t.getTop(this.el),
          i = Math.min(e, window.innerHeight) * (_globals.globalHide ? this.props.fraction : 0);
      return s > i - window.innerHeight && s < e - i;
    }
  }, {
    key: "hide",
    value: function value() {
      this.props.out && this.setState({
        style: {
          opacity: 0
        }
      });
    }
  }, {
    key: "resize",
    value: function value() {
      this && this.el && this.props.when && this.inViewport() && (this.clean(), this.isShown = !!this.props.when, this.setState({
        style: {
          opacity: this.props.when || !this.props.out ? 1 : 0
        }
      }), this.props.onReveal && this.props.when && this.props.onReveal());
    }
  }, {
    key: "invisible",
    value: function value() {
      this && !this.isShown && this.setState({
        style: (0, _extends3.default)({}, this.state.style, {
          visibility: "hidden"
        })
      });
    }
  }, {
    key: "animationEnd",
    value: function value(e, t) {
      var s = this;

      if (!t) {
        var i = this.finalEl || this.el,
            n = function t() {
          s && i && (i.removeEventListener("animationend", t), e.call(s));
        };

        i.addEventListener("animationend", n);
      }
    }
  }, {
    key: "collapse",
    value: function value(e, t) {
      if (t.collapse && t.out) {
        var s = t.duration + (t.cascade ? !0 === t.cascade ? 1e3 : t.cascade : 0),
            i = s >> 2,
            n = t.when ? i : s - i,
            o = t.delay + (t.when ? 0 : i);
        return (0, _extends3.default)({}, e, {
          height: t.when ? !0 === t.collapse ? this.dummyEl.offsetHeight : t.collapse : 0,
          transition: "height " + n + "ms ease " + o + "ms"
        });
      }

      return e;
    }
  }, {
    key: "animate",
    value: function value(e) {
      if (this && this.el) {
        if (this.clean(), e.effect) this.setState({
          legacyMode: !0
        });else {
          var t = e[e.when || !e.out ? "in" : "out"],
              s = e.out || e.when ? t.animation || t.make() : void 0;
          if (this.isShown === !!e.when) return;
          this.isShown = !!e.when, this.setState({
            style: this.collapse((0, _extends3.default)({
              animationName: s,
              animationDuration: e.duration + "ms",
              animationDelay: e.delay + "ms",
              animationIterationCount: e.forever ? "infinite" : e.count,
              animationFillMode: "both",
              opacity: 1
            }, t.style), e)
          }), !e.when && e.out && this.animationEnd(this.invisible, e.forever);
        }
        e.onReveal && e.when && e.onReveal();
      }
    }
  }, {
    key: "clean",
    value: function value() {
      this.isListener && (window.removeEventListener("scroll", this.revealHandler), window.removeEventListener("orientationchange", this.revealHandler), window.document.removeEventListener("visibilitychange", this.revealHandler), window.removeEventListener("resize", this.resizeHandler), this.isListener = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.clean(), _globals.ssr && (0, _globals.disableSsr)();
    }
  }, {
    key: "listen",
    value: function value() {
      this.isListener || (this.isListener = !0, window.addEventListener("scroll", this.revealHandler), window.addEventListener("orientationchange", this.revealHandler), window.document.addEventListener("visibilitychange", this.revealHandler), window.addEventListener("resize", this.resizeHandler));
    }
  }, {
    key: "reveal",
    value: function value(e) {
      var t = this;
      if (this && this.el) if (e || (e = this.props), this.inViewport()) {
        if (this.start) return this.hide(), this.listen(), void this.start(this.step);
        e.when && this.isShown && "spy" in e ? (this.isShown = !1, this.setState({
          style: {}
        }), window.setTimeout(function () {
          return t.animate.call(t, e);
        }, 200)) : this.animate(e);
      } else this.listen();
    }
  }, {
    key: "componentDidMount",
    value: function value() {
      if (this.el && !this.props.bypass) {
        if (this.props.force) return this.animate(this.props);
        this.props.step instanceof _Step2.default ? this.props.step.push(this) : this.props.step && this.context.stepper && this.context.stepper.get(this.props.step).push(this), _globals.ssr && (this.props.out || this.props.effect) && t.getTop(this.el) < window.pageYOffset + window.innerHeight ? (this.setState({
          style: {
            opacity: 0,
            transition: "opacity 1000ms"
          }
        }), window.setTimeout(this.revealHandler, 1e3)) : this.props.when && this.reveal(this.props);
      }
    }
  }, {
    key: "cascade",
    value: function value(e) {
      var t = this,
          s = void 0;
      s = "string" == typeof e ? e.split("").map(function (e, t) {
        return _react2.default.createElement("span", {
          key: t,
          style: {
            display: "inline-block",
            whiteSpace: "pre"
          }
        }, e);
      }) : _react2.default.Children.toArray(e);
      var i = s.length - 1,
          n = this.props.duration + (!0 === this.props.cascade ? 1e3 : this.props.cascade),
          o = 0;
      return s = s.map(function (e) {
        return _react2.default.cloneElement(e, {
          style: (0, _extends3.default)({}, e.props.style, t.state.style, {
            animationDuration: Math.round((0, _globals.cascade)(o++, 0, i, t.props.duration, n)) + "ms"
          }),
          ref: o === i ? function (e) {
            return t.finalEl = e;
          } : void 0
        });
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function value(e) {
      e.when === this.props.when && e.spy === this.props.spy || this.reveal(e);
    }
  }, {
    key: "dummy",
    value: function value(e) {
      var t = this;
      if (!0 !== this.props.collapse) return e;
      var s = [e, _react2.default.createElement(e.type, (0, _extends3.default)({}, this.props.props || void 0, {
        className: this.props.className,
        children: this.props.children,
        key: 2,
        ref: function ref(e) {
          return t.dummyEl = e;
        },
        style: (0, _extends3.default)({}, this.props.style, {
          position: "absolute",
          left: "-9999em",
          top: "-9999em",
          height: "auto",
          display: "block",
          animationName: "none",
          animationDuration: "0s",
          transition: "none",
          opacity: 0
        })
      }))];
      return _react2.default.createElement("span", null, s);
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.tag,
          s = e.id,
          i = e.children,
          n = e.style,
          o = e.className,
          r = (this.state.legacyMode ? this.props.effect : this.props.out || this.props.effect ? _globals.namespace : "") + (o ? " " + o : "") || void 0,
          a = void 0,
          p = !1;
      this.state.legacyMode || (a = (0, _extends3.default)({}, n, this.state.style), this.props.cascade && i && this.state.style.animationName && (p = this.cascade(i), a.animationName = void 0));

      var l = _react2.default.createElement(t, (0, _extends3.default)({}, this.props.props || void 0, {
        id: s,
        className: r,
        style: this.state.legacyMode ? n : a,
        key: this.props.collapse ? 1 : void 0,
        ref: this.saveRef
      }), p || i);

      return this.props.collapse ? this.dummy(l) : l;
    }
  }], [{
    key: "getTop",
    value: function value(e) {
      for (; void 0 === e.offsetTop;) {
        e = e.parentNode;
      }

      for (var t = e.offsetTop; e.offsetParent; t += e.offsetTop) {
        e = e.offsetParent;
      }

      return t;
    }
  }]), t;
}(_react2.default.Component);

RevealBase.propTypes = propTypes, RevealBase.defaultProps = defaultProps, RevealBase.contextTypes = contextTypes, exports.default = RevealBase, module.exports = exports.default;